module.exports = __webpack_public_path__ + "static/media/slider-arrow.ebb42335.svg";